// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"article-cover_skeleton__w5fsz","container":"article-cover_container__J9ntr","image":"article-cover_image__pJM2K"};